export function separateThousandsGroups(num: number | undefined | null) {
  if (num && !isNaN(num)) {
    return Math.round(num)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  if (num === 0) {
    return '0';
  }

  return '';
}
